import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Header = styled.div`
    justify-content: space-between;
    flex-direction: column;
    display: flex;
    width: 100%;
    gap: 8px;
    
`
export const Title = styled.div`
    font-family: Circular-Std-Bold;
    font-size: 20px;
    color: ${colors.titleStrongBlack};
`

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid ${colors.softGray};
    gap: 8px;
`
export const OptionsContainer = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    gap: 8px;
    padding-bottom: 8px;
`
export const Selected = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    gap: 8px;
    width: 100%;
    
`
export const Tag = styled.div`
    display: flex;
    align-items: center;
    border-radius: 24px;
    padding: 8px 12px;
    background-color: ${colors.softBlue};
    color: ${colors.strongBlue};
    font-size: 16px;
    gap: 4px;
`

export const ClearTag = styled.div`
    display: flex;
    align-items: center;
    border-radius: 24px;
    padding: 8px 12px;
    background-color: ${colors.softGray};
    color: ${colors.titleStrongBlack};
    font-size: 16px;
    gap: 4px;
    cursor: pointer;
`

export const CloseIcon = styled.div`
  cursor: pointer;
  font-size: 20px;
  color: ${colors.strongGray};
`

export const TopContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
`
export const DownloadIcon = styled.div`
  cursor: pointer;
  color: ${colors.strongGray};
  margin-left: 12px;
`
